import ApiService from '@/services/core/api.service'

const PendingApprovalService = {
  async get (query) {
    return ApiService.get(`rad/pending-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('rad/pending-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`rad/pending-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`rad/pending-approvals/${payload.id}`)
  }
}

export default PendingApprovalService
